(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sr-finish-gallery"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (event) {
  const trigger = event.target.closest('[data-sr-finish-open]');
  if (trigger) {
    const dialog = document.getElementById(trigger.dataset.srFinishOpen);
    if (dialog && !dialog.open) dialog.showModal();
  }
  const close = event.target.closest('[data-sr-finish-close]');
  if (close) close.closest('dialog').close();
  if (event.target.matches('.sr-finish-dialog')) {
    const box = event.target.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) event.target.close();
  }
});

  } catch(e) { console.error(e); }
})();
})();
